module.exports = __webpack_public_path__ + "img/phone_white_icon.be7a59aa.svg";